import React, { useState } from "react";
import { View } from "react-native";
import { Button, TextInput, Dialog, Checkbox } from "react-native-paper";
import services from "../../../services";

const FormNewUser = ({ visible, onDismiss, onComplete }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [pwd, setPassword] = useState('');
  const [isAdministrator, setAdmin] = useState(false);
  const [isEmployee, setEmployee] = useState(false);

  const onSubmit = () => {
    if(!isAdministrator && !isEmployee) {
      alert('No has seleccionat el rol');
    } else {
      services.users.create({
        name: name,
        email: email,
        password: pwd,
        isAdministration: isAdministrator,
        isEmployee: isEmployee
      }).then((res) => {
        setName('');
        setEmail('');
        setPassword('');
        setAdmin(false);
        setEmployee(false);
        onComplete();
      });
    }
  }

  return (
    <Dialog style={{
      width: '33%',
      alignSelf: 'center'
    }} visible={visible} onDismiss={onDismiss}>
      <Dialog.Content>
        <View style={{
          flexDirection: 'column',
          marginBottom: 12
        }}>
          <TextInput
            style={{
              flex: 1,
              marginBottom: 12
            }}
            label="Nom"
            value={name}
            onChangeText={text => setName(text)}
          />
          <TextInput
            style={{
              flex: 1,
              marginBottom: 12
            }}
            label="Correu electrònic"
            value={email}
            onChangeText={text => setEmail(text)}
          />
          <TextInput
            style={{
              flex: 1,
            }}
            label="Contrasenya"
            value={pwd}
            onChangeText={text => setPassword(text)}
          />
        </View>
        <View style={{
          flexDirection: 'row',
          marginBottom: 12
        }}>
          <View>
            <Checkbox.Item label="Rol Administrador" onPress={() => setAdmin(!isAdministrator)}
              status={isAdministrator ? "checked" : "unchecked"} />
          </View>
          <View>
            <Checkbox.Item label="Rol empleat" onPress={() => setEmployee(!isEmployee)}
              status={isEmployee ? "checked" : "unchecked"} />
          </View>
        </View>
        <Button mode="contained" onPress={onSubmit}>
          Crear usuari
        </Button>
      </Dialog.Content>
    </Dialog>
  );

};

export default FormNewUser;
